import React, { useState } from "react";
import {
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import IconMl from "./assets/icon-ml.svg";
import IconNsl from "./assets/icon-nsl.svg";
import IconDue from "./assets/icon-due.svg";
import IconLegal from "./assets/icon-legal.svg";
import IconJournalist from "./assets/icon-journalists.svg";
import IconBNO from "./assets/icon-bno.svg";
import ArrowBlue from "./assets/arrow-blue.svg";
import ArrowGreen from "./assets/arrow-green.svg";
import ArrowTeal from "./assets/arrow-teal.svg";
import ArrowPurple from "./assets/arrow-purple.svg";
import ArrowOrange from "./assets/arrow-orange.svg";
import ArrowRed from "./assets/arrow-red.svg";

function Home() {
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  const [showNSL, setShowNSL] = useState(false);
  const [showDue, setShowDue] = useState(false);
  const [showLegal, setShowLegal] = useState(false);
  const [showJournalist, setShowJournalist] = useState(false);

  return (
    <Container className={classes.container} maxWidth="xl">
      <Grid container spacing={1}>
        <Grid item sm={12} md={12}>
          <Link
            to={`/${i18n.language}/national-security-law`}
            className={classes.link}
          >
            <Card
              className={[classes.card, classes.nationalSecurityLaw].join(" ")}
            >
              <span />
              <CardContent>
                <div className={classes.titleWrapper}>
                  <img src={IconNsl} alt="Hong Kong’s National Security Law" />
                  <h2 className={classes.title}>
                    {t("National Security Law")}
                  </h2>
                </div>
                <Typography className={classes.description}>
                  {showNSL
                    ? t(
                        "When China directly inserted its National Security Law into Hong Kong’s constitution in June 2020, the city’s legal and political environment was transformed.\n\nAuthorities claim the legislation has been critical in bringing stability and peace to Hong Kong following anti-China protests in 2019. The sweeping powers it has given to authorities, however, have helped tighten freedom of speech and silence opposition to establishment rule.\n\nUnderstanding the NSL, what offences it covers, who can be charged under it, how it is enforced and the ways in which it has been used since it was introduced is important to ensure you do not fall foul of the legislation."
                      )
                    : t(
                        "When China directly inserted its National Security Law into Hong Kong’s constitution in June 2020, the city’s legal and political environment was transformed.\n\nAuthorities claim the legislation has been critical in bringing stability and peace to Hong Kong following anti-China protests in 2019. The sweeping powers it has given to authorities, however, have helped tighten freedom of speech and silence opposition to establishment rule..."
                      )}
                  {!showNSL && (
                    <span
                      className={classes.showMore}
                      style={{ color: "#ED882B" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowNSL(true);
                      }}
                    >
                      {t("Show more")} &gt;
                    </span>
                  )}
                </Typography>
                <div className={[classes.arrow, "arrow"].join(" ")}>
                  <img src={ArrowOrange} alt="Security Law" />
                </div>
              </CardContent>
            </Card>
          </Link>
        </Grid>
        <Grid item sm={12} md={12}>
          <Link
            to={`/${i18n.language}/police-encounters`}
            className={classes.link}
          >
            <Card className={[classes.card, classes.dueProcess].join(" ")}>
              <span />
              <CardContent>
                <div className={classes.titleWrapper}>
                  <img src={IconDue} alt="Police encounters" />
                  <h2 className={classes.title}>{t("Police encounters")}</h2>
                </div>
                <Typography className={classes.description}>
                  {showDue
                    ? t(
                        "What is your experience with police encounters in Hong Kong? Are you aware of your rights in a search or an arrest? Has someone you care about been charged with an offence? \n\nDue process is a requirement on authorities to guarantee protections of legal rights of the individuals, and the proper application of law. \n\nYou have rights throughout the process. Understand them, exercise them, and know what your options are if you feel that your civil liberties and fundamental rights are at risk."
                      )
                    : t(
                        "What is your experience with police encounters in Hong Kong? Are you aware of your rights in a search or an arrest? Has someone you care about been charged with an offence? \n\nDue process is a requirement on authorities to guarantee protections of legal rights of the individuals, and the proper application of law. \n\nYou have rights throughout the process. Understand them..."
                      )}
                  {!showDue && (
                    <span
                      className={classes.showMore}
                      style={{ color: "#2E9999" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowDue(true);
                      }}
                    >
                      {t("Show more")} &gt;
                    </span>
                  )}
                </Typography>
                <div className={[classes.arrow, "arrow"].join(" ")}>
                  <img src={ArrowTeal} alt="Police encounters" />
                </div>
              </CardContent>
            </Card>
          </Link>
        </Grid>
        <Grid item sm={12} md={12}>
          <Link
            to={`/${i18n.language}/guidance-for-journalists`}
            className={classes.link}
          >
            <Card className={[classes.card, classes.journalists].join(" ")}>
              <span />
              <CardContent>
                <div className={classes.titleWrapper}>
                  <img src={IconJournalist} alt="Guidance for journalists" />
                  <h2 className={classes.title}>
                    {t("Guidance for journalists")}
                  </h2>
                </div>
                <Typography className={classes.description}>
                  {showJournalist
                    ? t(
                        "The Beijing-imposed National Security Law has had a profound and far-reaching impact on Hong Kong’s media environment. Used alongside the colonial-era sedition law that had been dormant since the 1970s, the legislation has limited press freedom and freedom of speech.\n\nThree prominent publications were forced to close for their editorial stance. Several other outlets have shuttered, citing security concerns. Those still operating self-censor or tone down their reporting on sensitive political matters, fearing repercussions under the new law.\n\nThis has had a chilling effect on reporters who now fear falling foul of legislation that authorities are using to silence dissent and criticism. This guidance helps journalists navigate their legal rights when interacting with the police in public, accessing public records, and being served a search warrant or production order."
                      )
                    : t(
                        "The Beijing-imposed National Security Law has had a profound and far-reaching impact on Hong Kong’s media environment. Used alongside the colonial-era sedition law that had been dormant since the 1970s, the legislation has limited press freedom and freedom of speech.\n\nThree prominent publications were forced to close for their editorial stance. Several other outlets have shuttered, citing security concerns. Those still operating self-censor or tone down their reporting on..."
                      )}
                  {!showJournalist && (
                    <span
                      className={classes.showMore}
                      style={{ color: "#DB4B38" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowJournalist(true);
                      }}
                    >
                      {t("Show more")} &gt;
                    </span>
                  )}
                </Typography>
                <div className={[classes.arrow, "arrow"].join(" ")}>
                  <img src={ArrowRed} alt="Guidance for journalists" />
                </div>
              </CardContent>
            </Card>
          </Link>
        </Grid>
        <Grid item sm={12} md={12}>
          <Link to={`/${i18n.language}/legal-aid`} className={classes.link}>
            <Card className={[classes.card, classes.legalAid].join(" ")}>
              <span />
              <CardContent>
                <div className={classes.titleWrapper}>
                  <img src={IconLegal} alt="Legal Aid" />
                  <h2 className={classes.title}>{t("Legal Aid")}</h2>
                </div>
                <Typography className={classes.description}>
                  {showLegal
                    ? t(
                        "Are you in need of legal assistance in Hong Kong? You have the right to legal advice and representation, and this right shouldn’t be hampered by costs. \n\nAccess to justice is more than protecting individual interests in legal proceedings. Our society depends on it - an accessible legal system enables the public to trust the courts to administer law in a fair and just manner.\n\nIn reality, navigating the judicial system can be a daunting experience, and seeking expert legal advice and engaging legal representation can be expensive. If you don’t have the means, there are various platforms and schemes in Hong Kong that may be available to you. Find out which one is right for you."
                      )
                    : t(
                        "Are you in need of legal assistance in Hong Kong? You have the right to legal advice and representation, and this right shouldn’t be hampered by costs. \n\nAccess to justice is more than protecting individual interests in legal proceedings. Our society depends on it - an accessible legal system enables the public to trust the courts to administer law in a fair and just manner.\n\nIn reality, navigating the judicial system can be a daunting..."
                      )}
                  {!showLegal && (
                    <span
                      className={classes.showMore}
                      style={{ color: "#6E77CC" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowLegal(true);
                      }}
                    >
                      {t("Show more")} &gt;
                    </span>
                  )}
                </Typography>
                <div className={[classes.arrow, "arrow"].join(" ")}>
                  <img src={ArrowPurple} alt="Legal Aid" />
                </div>
              </CardContent>
            </Card>
          </Link>
        </Grid>
        <Grid item sm={12} md={12}>
          <Link
            to={`/${i18n.language}/money-laundering`}
            className={classes.link}
          >
            <Card className={[classes.card, classes.moneyLaundering].join(" ")}>
              <span />
              <CardContent>
                <div className={classes.titleWrapper}>
                  <img src={IconMl} alt="Understanding HK\'s Laws" />
                  <h2 className={classes.title}>{t("Money laundering")}</h2>
                </div>
                <Typography className={classes.description}>
                  {t(
                    "Hong Kong’s lawbook can be complicated and overwhelming, and the ways in which existing legislation is being used are changing as the political landscape in the city shifts. Activities that were once benign, such as crowdfunding, may now carry risks.\n\nIt is important you stay vigilant and aware of how the application of these laws evolve. Understanding the nuances and implications of specific legislation can help you stay on the right side of the law."
                  )}
                </Typography>
                <div className={[classes.arrow, "arrow"].join(" ")}>
                  <img src={ArrowBlue} alt="Money laundering" />
                </div>
              </CardContent>
            </Card>
          </Link>
        </Grid>
        <Grid item sm={12} md={12}>
          <Link to={`/${i18n.language}/emigrating-uk`} className={classes.link}>
            <Card className={[classes.card, classes.emigratingUk].join(" ")}>
              <span />
              <CardContent>
                <div className={classes.titleWrapper}>
                  <img src={IconBNO} alt="Emigrating to the UK" />
                  <h2 className={classes.title}>{t("Emigrating to the UK")}</h2>
                </div>
                <Typography className={classes.description}>
                  {t(
                    "Some Hong Kongers can relocate to the UK with a British National (Overseas) (BNO) visa. Others who are already in the UK and fear returning to Hong Kong due to persecution related to their political opinion or for specific other reasons can apply to the UK government to stay in the UK as refugees.\n\nThis is a guide to the asylum system in the UK and the BNO visa scheme."
                  )}
                </Typography>
                <div className={[classes.arrow, "arrow"].join(" ")}>
                  <img src={ArrowGreen} alt="Emigrating to the UK" />
                </div>
              </CardContent>
            </Card>
          </Link>
        </Grid>
      </Grid>
    </Container>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "100px 60px",
    [theme.breakpoints.down("sm")]: {
      padding: "60px 20px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0px",
    },
    "& > .MuiGrid-container > .MuiGrid-item": {
      padding: "20px 10px",
      [theme.breakpoints.down("xs")]: {
        padding: "0px",
      },
    },
  },
  card: {
    position: "relative",
    background: "#F8F6F3",
    marginTop: "0",
    padding: "60px 84px",
    color: theme.palette.text.primary,
    fontFamily: "Manrope",
    whiteSpace: "pre-line",
    borderRadius: 0,
    boxShadow: "none",
    [theme.breakpoints.down("sm")]: {
      padding: "40px 30px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "60px 20px",
    },
    "& .MuiCardContent-root": {
      display: "flex",
      alignItems: "flex-start",
      gap: "40px",
      padding: "0px",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        gap: "24px",
      },
    },
    "& > span": {
      display: "block",
      position: "absolute",
      top: 0,
      left: "84px",
      width: "30%",
      height: "5px",
      background: "#2E9999",
      // transform: "translateX(-50%)",
      transition: "all 0.6s ease-in-out",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        left: "0%",
        height: "6px",
      },
    },
  },
  showMore: {
    fontWeight: 700,
    paddingLeft: "6px",
  },
  topRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  description: {
    margin: "0",
    fontSize: "16px",
    lineHeight: 1.5,
    transition: "color 0.8s",
    [theme.breakpoints.down("sm")]: {
      margin: "0",
      fontSize: "14px",
    },
  },
  cta: {
    margin: "30px 0",
    textTransform: "uppercase",
  },
  linkText: {
    display: "inline-block",
    verticalAlign: "middle",
    fontSize: "16px",
    fontWeight: "bold",
    letterSpacing: "0.1em",
    maxWidth: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    transition: "all 0.8s ease-in-out",
  },
  arrow: {
    "& img": {
      maxWidth: "44px",
    },
    [theme.breakpoints.down("sm")]: {
      display: "inline-flex",
      justifyContent: "flex-end",
      width: "100%",
    },
  },
  dueProcess: {
    "& $linkText": {
      color: "#2E9999",
    },
  },
  legalAid: {
    "& > span": {
      background: "#6E77CC",
    },
    "& $linkText": {
      color: "#6E77CC",
    },
  },
  journalists: {
    "& > span": {
      background: "#DB4B38",
    },
    "& $linkText": {
      color: "#DB4B38",
    },
  },
  nationalSecurityLaw: {
    "& > span": {
      background: "#C99639",
    },
    "& $linkText": {
      color: "#C99639",
    },
  },
  moneyLaundering: {
    "& > span": {
      background: "#3F82E0",
    },
    "& $linkText": {
      color: "#3F82E0",
    },
  },
  emigratingUk: {
    "& > span": {
      background: "#05403F",
    },
    "& $linkText": {
      color: "#05403F",
    },
  },
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    minWidth: "463px",
    [theme.breakpoints.down("md")]: {
      minWidth: "360px",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "0px",
    },
    "& img": {
      width: "40px",
      height: "40px",
    },
  },
  title: {
    fontWeight: 700,
    fontSize: "30px",
    lineHeight: 1.2,
    margin: "0px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "24px",
    },
  },
  link: {
    display: "block",
    textDecoration: "none",
    height: "100%",
    "& > div": {
      height: "100%",
      transition: "all 0.3s",
    },
    "& .arrow": {
      transition: "all 0.5s",
    },
    "&:hover": {
      "& > div > span": {
        width: "100%",
        left: "0%",
      },
      "& $linkText": {
        maxWidth: "200px",
      },
      "& .arrow": {
        transform: "translateX(20px)",
      },
    },
  },
}));

export default Home;
